<template>
  <div>
    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseOrderItem" max-width="800px" scrollable eager>
      <OrderItemBrowse ref="OrderItemBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </OrderItemBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseTestItem" max-width="800px" scrollable eager>
      <TestItemBrowse ref="TestItemBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </TestItemBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseAnalyzer" max-width="800px" scrollable eager>
      <AnalyzerBrowse ref="AnalyzerBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </AnalyzerBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseIQCLot" max-width="800px" scrollable eager>
      <IQCLotBrowse ref="IQCLotBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </IQCLotBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseResultItem" max-width="800px" scrollable eager>
      <ResultItemBrowse ref="ResultItemBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </ResultItemBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseIQCLotControl" max-width="800px" scrollable eager>
      <IQCLotControlBrowse ref="IQCLotControlBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </IQCLotControlBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseIQControlName" max-width="800px" scrollable eager>
      <IQCControlNameBrowse ref="IQCControlNameBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </IQCControlNameBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseAnalyzerModel" max-width="800px" scrollable eager>
      <AnalyzerModelBrowse ref="AnalyzerModelBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </AnalyzerModelBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogIQCResultAutoCalc" max-width="800px" scrollable eager>
      <LISIQCResultAutoCalc ref="LISIQCResultAutoCalc"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </LISIQCResultAutoCalc>
    </v-dialog>
    <v-toolbar scrollable color="light-blue darken-4" dark>
      <v-spacer></v-spacer>
      <v-btn ref = "buttonNew" color="primary" style="text-transform: capitalize" @click="newIQCLot" :disabled="disabledControl.buttonNew">
        <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('new')}}
      </v-btn>
      <v-btn ref = "buttonDelete" color="primary" style="text-transform: capitalize" @click="deleteIQCLot" :disabled="disabledControl.buttonDelete">
        <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('delete')}}
      </v-btn>
      <v-btn ref = "buttonSave" color="primary" style="text-transform: capitalize" @click="saveIQCLot" :disabled="disabledControl.buttonSave">
        <img src="../assets/SoftwareClinicIcon/Save.png" height="30" weight="30"/>{{$t('save')}}
      </v-btn>
      <v-btn ref = "buttonQuery" color="primary" style="text-transform: capitalize" @click="queryIQCLot" :disabled="disabledControl.buttonQuery">
        <img src="../assets/SoftwareClinicIcon/Query.png" height="30" weight="30"/>{{$t('query')}}
      </v-btn>
      <v-btn ref = "buttonFind" color="primary" style="text-transform: capitalize" @click="findIQCLot" :disabled="disabledControl.buttonFind">
        <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            color="primary"
            dark
            v-bind="attrs"
            v-on="on">
            <v-icon dark>list</v-icon>
          </v-btn>
        </template>
          <v-list>
            <v-list-tile @click="OpenAutoSelect">
              <img src="../assets/SoftwareClinicIcon/Query.png" height="30" weight="30"/>
              <v-list-tile-title>&nbsp;Auto Select</v-list-tile-title>
            </v-list-tile>
          </v-list>
          <v-list>
            <v-list-tile @click="Calculate">
              <img src="../assets/SoftwareClinicIcon/Query.png" height="30" weight="30"/>
              <v-list-tile-title>&nbsp;Calculate</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu> 
    </v-toolbar>
    <v-container grid-list-xs text-xs-center fluid>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="2" class="pt-2 pb-1 mb-1">
              <v-dialog
                ref="dialogDateFromTo"
                v-model="dialog.dialogDateFromTo"
                :return-value.sync="criteria.dateFromTo"
                persistent
                width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeTextDateFromTo"
                    label="Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="clearDateFromToCriteria"
                    clearable></v-text-field>
                </template>
                <v-date-picker
                  v-model="criteria.dateFromTo"
                  range
                  scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dialog.dialogDateFromTo = false">{{$t('cancel')}}</v-btn>
                  <v-btn text color="primary" @click="$refs.dialogDateFromTo.save(criteria.dateFromTo)">{{$t('ok')}}</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field label="Lot Control" v-model="criteria.lotControl"
                outlined dense hide-details readonly
                @click:clear="clearLotControl"
                clearable>
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="blue" @click="browseLotControl">mdi-file-find</v-icon>
                    </template>
                    Search Lot Control
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field label="Control Name" v-model="criteria.controlName"
                outlined dense hide-details readonly
                @click:clear="clearControlName"
                clearable>
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="blue" @click="browseControlName">mdi-file-find</v-icon>
                    </template>
                    Search Control Name
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-select :items="dropDownData.lis_iqc_level" v-model="criteria.level_cd" item-text="level_desc" item-value="level_cd" label="Level" persistent-hint outlined dense hide-details>
              </v-select>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" sm="12" md="3">
              <v-text-field label="Analyzer" v-model="criteria.analyzer_cd"
                outlined dense hide-details readonly
                @click:clear="clearAnalyzer"
                clearable>
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="blue" @click="browseAnalyzer">mdi-file-find</v-icon>
                    </template>
                    Search Analyzer
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Analyzer Desc" v-model="criteria.analyzer_desc" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field label="Analyzer Model" v-model="criteria.model_cd"
                outlined dense hide-details readonly
                @click:clear="clearAnalyzerModel"
                clearable>
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="blue" @click="browseAnalyzerModel">mdi-file-find</v-icon>
                    </template>
                    Search Analyzer Model
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Analyzer Model Desc" v-model="criteria.model_desc" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" sm="12" md="3">
              <v-text-field label="Result Item" v-model="criteria.result_item_id"
                outlined dense hide-details readonly
                @click:clear="clearResultItem"
                clearable>
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="blue" @click="browseResultItem">mdi-file-find</v-icon>
                    </template>
                    Search Result Item
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Result Item Desc" v-model="criteria.result_item_desc" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Analyzer Serial No" v-model="criteria.analyzer_serial_no" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" sm="12" md="3">
              <v-menu v-model="menu.menuStartDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense hide-details outlined v-model="criteria.start_date" label="Start Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="criteria.start_date" @input="menu.menuStartDate = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu v-model="menu.menuExpiredDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense hide-details outlined v-model="criteria.expired_date" label="Expired Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="criteria.expired_date" @input="menu.menuExpiredDate = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field label="ICQ Lot No." v-model="criteria.iqc_lot_no"
                outlined dense hide-details readonly
                @click:clear="clearIQCLot"
                clearable>
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="blue" @click="browseIQCLot">mdi-file-find</v-icon>
                    </template>
                    Search IQC Lot No.
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Reference Lot No." v-model="criteria.ref_lot_no" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
    </v-container> 
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headers"
      :items="vDataTable.data"
      :search="vDataTable.search"
      show-select
      fixed-header
      :expanded.sync="vDataTable.expanded"
      show-expand
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      :height="600"
      @click:row="onRowClick"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="uid">
      <template v-slot:header.win_name="{ header }">
          {{ header.text.toUpperCase() }}
      </template>
      <template v-slot:header.data-table-select="{ on, props }">
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTable.selected.length > 0">
            {{vDataTable.selected.length}}
          </td>
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog.dialogAddEdit" max-width="1000px" eager>
            <template v-slot:activator="{ on, attrs }">
              <!-- <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newResultItem()">
                <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
              </v-btn> -->
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
               <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field label="Result Item" v-model="vDataTable.editedItem.result_item_id"
                      outlined dense hide-details readonly
                      @click:clear="clearResultItem"
                      clearable>
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="blue" @click="browseResultItem">mdi-file-find</v-icon>
                          </template>
                          Search Result Item
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field label="Result Item Description" v-model="vDataTable.editedItem.result_item_desc" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">  
                      <v-text-field label="Target Mean" v-model="vDataTable.editedItem.target_mean" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">  
                      <v-text-field label="Target SD" v-model="vDataTable.editedItem.target_sd" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">  
                      <v-text-field label="Lab Mean" v-model="vDataTable.editedItem.lab_mean" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">  
                      <v-text-field label="Lab SD" v-model="vDataTable.editedItem.lab_sd" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">  
                      <v-text-field label="N" v-model="vDataTable.editedItem.n" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-textarea
                        v-model="vDataTable.editedItem.remark"
                        outlined hide-details
                        color="black"
                        label="Remark">
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="close">{{$t('cancel')}}</v-btn>
                  <v-btn outlined color="primary" @click="save" :disabled="disabledControl.buttonSaveDetail">{{$t('save')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-text-field v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <!-- <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template> -->
      <template v-slot:item.data-table-no="{ item, index }">
        {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
      </template>
      <template v-slot:no-data>
        <v-alert type="info">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{stringFormat($t('searchNotFound'),vDataTable.search)}}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td>Selected({{vDataTable.selected.length}})s</td> 
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers, item }"> 
        <td :colspan="headers.length">
          <v-data-table v-model="item.selectedIQCLotResultValue" 
                                  :headers="subHeadersIQCLotResultValue"
                                  :items="item.lis_iqc_lot_result_value"
                                  :search="item.searchIQCLotResultValue"
                                  :page.sync="vDataTable.options.page"
                                  :itemsPerPage.sync="vDataTable.options.itemsPerPage"
                                  :options.sync="vDataTable.options"
                                  :footer-props="{
                                    itemsPerPageText: $t('itemsPerPageText'),
                                    itemsPerPageAllText: $t('itemsPerPageAllText'),
                                    showFirstLastPage: true,
                                    showCurrentPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    prevIcon: 'mdi-minus',
                                    nextIcon: 'mdi-plus',
                                  }"
                                  item-key="uid"
                                  class="elevation-1">
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Result Value</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog.dialogAddEditResultValue" max-width="500px" eager>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newIQCLotResultValue(item)">
                              <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
                            </v-btn>        
                          </template>
                          <v-card>
                            <v-card-title>
                              <span class="headline">{{ formIQCLotResultValueTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" sm="12" md="12">
                                    <v-menu v-model="menu.menuQCDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-text-field dense hide-details outlined v-model="vDataTable.editedResultValueItem.qc_date" label="QC Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker v-model="vDataTable.editedResultValueItem.qc_date" @input="menu.menuQCDate = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="12">
                                    <v-text-field label="Result Value" v-model="vDataTable.editedResultValueItem.result_value" type="number" outlined dense hide-details></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="12">  
                                    <v-textarea
                                      v-model="vDataTable.editedResultValueItem.comment"
                                      outlined hide-details
                                      color="black"
                                      label="Comment">
                                    </v-textarea>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="12">  
                                    <v-textarea
                                      v-model="vDataTable.editedResultValueItem.remark"
                                      outlined hide-details
                                      color="black"
                                      label="Remark">
                                    </v-textarea>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="2">
                                    <v-checkbox v-model="vDataTable.editedResultValueItem.comment_flag" label="Comment" hide-details>
                                    </v-checkbox>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="2">
                                    <v-checkbox v-model="vDataTable.editedResultValueItem.calc_flag" label="Cal" hide-details>
                                    </v-checkbox>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="2">
                                    <v-checkbox v-model="vDataTable.editedResultValueItem.graph_flag" label="Graph" hide-details>
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                                <v-btn outlined color="primary" @click="closeResultValue">{{$t('cancel')}}</v-btn>
                                <v-btn outlined color="primary" @click="saveResultValue">{{$t('save')}}</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="item.searchLanguage" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-icon color="teal" small class="mr-2" @click="editResultValue(item)">edit</v-icon>
                      <v-icon color="pink" small class="mr-2" @click="deleteResultValueConfirm(item)">delete</v-icon>
                    </template>
                    <template v-slot:item.comment_flag="{ item }">
                      <v-simple-checkbox v-model="item.comment_flag" disabled hide-details>
                      </v-simple-checkbox>
                    </template>
                    <template v-slot:item.calc_flag="{ item }">
                      <v-simple-checkbox v-model="item.calc_flag" disabled hide-details>
                      </v-simple-checkbox>
                    </template>
                    <template v-slot:item.graph_flag="{ item }">
                      <v-simple-checkbox v-model="item.graph_flag" disabled hide-details>
                      </v-simple-checkbox>
                    </template>
                  </v-data-table>
        </td>
      </template>
    </v-data-table>
    <v-tabs>
      <v-tab style="text-transform: capitalize"> Target </v-tab>
      <v-tab-item  eager>
        <apexchart ref = "chartTarget" type="line" width="100%" height="550px" :options="chartOptionsLine" :series="series"></apexchart>
      </v-tab-item>
      <v-tab style="text-transform: capitalize"> Lab </v-tab>
      <v-tab-item  eager>
        <apexchart ref = "chartLab" type="line" width="100%" height="550px" :options="chartOptionsLine" :series="series"></apexchart>
      </v-tab-item>
      <v-tab style="text-transform: capitalize"> All </v-tab>
      <v-tab-item  eager>
        <apexchart ref = "chartAll" type="line" width="100%" height="550px" :options="chartOptionsLine" :series="series"></apexchart>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import OrderItemBrowse from '@/components/common/OrderItemBrowse'
import TestItemBrowse from '@/components/common/TestItemBrowse'
import AnalyzerBrowse from '@/components/common/AnalyzerBrowse'
import IQCLotBrowse from '@/components/common/IQCLotBrowse'
import ResultItemBrowse from '@/components/common/ResultItemBrowse'
import IQCLotControlBrowse from '@/components/common/IQCLotControlBrowse'
import IQCControlNameBrowse from '@/components/common/IQCControlNameBrowse'
import AnalyzerModelBrowse from '@/components/common/AnalyzerModelBrowse'
import LISIQCResultAutoCalc from '@/components/LISIQCResultAutoCalc'

export default {
  components: {
    OrderItemBrowse,
    TestItemBrowse,
    AnalyzerBrowse,
    IQCLotBrowse,
    ResultItemBrowse,
    IQCLotControlBrowse,
    IQCControlNameBrowse,
    AnalyzerModelBrowse,
    LISIQCResultAutoCalc,
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      dialog: {
        dialogProgress: false,
        dialogAddEdit: false,
        dialogAddEditResultValue: false,
        dialogBrowseOrderItem: false,
        dialogBrowseTestItem: false,
        dialogBrowseAnalyzer: false,
        dialogBrowseIQCLot: false,
        dialogBrowseResultItem: false,
        dialogBrowseIQCLotControl: false,
        dialogBrowseIQControlName: false,
        dialogBrowseAnalyzerModel: false,
        dialogDateFromTo: false,
        dialogIQCResultAutoCalc: false,
      },
      stateWindow: '',
      readOnlyControl: {
        textFieldIQCLotNo: false,
      },
      disabledControl: {
        buttonNew: false,
        buttonDelete: false,
        buttonSave: false,
        buttonQuery: false,
        buttonFind: false,
        buttonSaveDetail: false,
      },
      menu: {
        menuStartDate: false,
        menuExpiredDate: false,
        menuQCDate: false,
      },
      IQCLotData: [],
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedResultValueIndex: -1,
        editedResultValueItem: {
        },
        defaultResultValueItem: {
        },
        options: {
          page: 1,
          itemsPerPage: -1,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      sendVar: [],
      dropDownData: [],
      progressMessage: '',
      criteria: {
        dateFromTo: [],
        lotControl: '',
        controlName: '',
        level_cd: '',
        analyzer_skey: -1,
        analyzer_cd: '',
        analyzer_desc: '',
        model_skey: -1,
        model_cd: '',
        model_desc: '',
        result_item_skey: -1,
        result_item_id: '',
        result_item_desc: '',
        analyzer_serial_no: '',
        start_date: '',
        expired_date: '',
        lot_skey: -1,
        iqc_lot_no: '',
        ref_lot_no: '',
      },
      series: [],
      chartOptionsLine: {
        chart: {
          height: 350,
          type: 'line',
        },
        stroke: {
          width: []
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: [],
      },
      data: {
        dataChartLine: {},
        dataSeriesLine: {},
        dataSelectLine: {},
        dataSeriesBar: {},
      },
      iqcLotResultValueEdit: true,
      NLabMean: null,
    }
  },

  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    ...mapState({
      userID: state => `${state.user.profile.user_id}`,
      userFullName: state => `${state.user.profile.user_fullname}`,
    }),
    dateRangeTextDateFromTo () {
      return this.criteria.dateFromTo.join(' ~ ')
    },
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? 'New Result Item' : 'Edit Result Item'
    },
    formIQCLotResultValueTitle () {
      return this.vDataTable.editedSubCustomerIssueTypeIndex === -1 ? 'New Result Value' : 'Edit Result Value'
    },
    headers () {
      return [
        { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: 'Analyzer Description', align: 'left', value: 'analyzer_desc', class: 'text-xl-left body-1 black--text' },
        { text: 'Analyzer Serial No', align: 'left', value: 'serial_no', class: 'text-xl-left body-1 black--text' },
        { text: 'Result Item Description', align: 'left', value: 'result_item_desc', class: 'text-xl-left body-1 black--text' },
        { text: 'UOM', width: '200', align: 'left', value: 'uom_desc', class: 'text-xl-left body-1 black--text' },
        { text: 'Level', width: '200', align: 'left', value: 'level_desc', class: 'text-xl-left body-1 black--text' },
        { text: 'Lot Control', align: 'left', value: 'lot_control', class: 'text-xl-left body-1 black--text' },
        { text: 'Control Name', align: 'left', value: 'control_name', class: 'text-xl-left body-1 black--text' },
        { text: 'Target Mean', align: 'left', value: 'target_mean', class: 'text-xl-left body-1 black--text' },
        { text: 'Target SD', align: 'left', value: 'target_sd', class: 'text-xl-left body-1 black--text' },
        { text: 'Lab Mean', align: 'left', value: 'lab_mean', class: 'text-xl-left body-1 black--text' },
        { text: 'Lab SD', align: 'left', value: 'lab_sd', class: 'text-xl-left body-1 black--text' },
        { text: 'Remark', align: 'left', value: 'remark', class: 'text-xl-left body-1 black--text' },
        { text: 'Mean', align: 'left', value: 'mean', class: 'text-xl-left body-1 black--text' },
        { text: 'SD', align: 'left', value: 'sd', class: 'text-xl-left body-1 black--text' },
        { text: '% CV', align: 'left', value: 'cv_pct', class: 'text-xl-left body-1 black--text' },
        { text: '% CV Lab Mean', align: 'left', value: 'cv_pct_lab_mean', class: 'text-xl-left body-1 black--text' },
        { text: 'N Lab Mean', align: 'left', value: 'n_lab_mean', class: 'text-xl-left body-1 black--text' },
        { text: 'N', align: 'left', value: 'n', class: 'text-xl-left body-1 black--text' },
      ]
    },
    subHeadersIQCLotResultValue () {
      return [
        // { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        // { text: 'Result Item ID', align: 'left', value: 'result_item_id', class: 'text-xl-left body-1 black--text' },
        // { text: 'Result Item Description', align: 'left', value: 'result_item_desc', class: 'text-xl-left body-1 black--text' },
        { text: 'QC Date', width: '200', align: 'left', value: 'qc_date', class: 'text-xl-left body-1 black--text' },
        { text: 'Result Value', align: 'left', value: 'result_value', class: 'text-xl-left body-1 black--text' },
        { text: 'Result Type', align: 'left', value: 'result_type', class: 'text-xl-left body-1 black--text' },
        { text: 'Comment', align: 'left', value: 'comment', class: 'text-xl-left body-1 black--text' },
        { text: 'Remark', align: 'left', value: 'remark', class: 'text-xl-left body-1 black--text' },
        { text: 'Comment', align: 'left', value: 'comment_flag', class: 'text-xl-left body-1 black--text' },
        { text: 'Cal', align: 'left', value: 'calc_flag', class: 'text-xl-left body-1 black--text' },
        { text: 'Graph', align: 'left', value: 'graph_flag', class: 'text-xl-left body-1 black--text' },
      ]
    },
    offsetAppBar () {
      return this.getShowAppBar ? this.getAppBarHeight : 0
    }
  },

  watch: {
    'dialog.dialogAddEdit' (val) {
      val || this.close()
    },
    stateWindow: function (after, before) {
      try {
        switch (after) {
          case 'NewState':
            this.disabledControl.buttonNew = true
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = true
            this.$refs.textFieldIQCLotNo.focus()
            break
          case 'DeleteState':
            this.disabledControl.buttonNew = true
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = true
            break
          case 'SaveState':
            this.disabledControl.buttonNew = true
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            break
          case 'QueryState':
            this.disabledControl.buttonNew = true
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = true
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            break
          case 'FindState':
            this.disabledControl.buttonNew = true
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            break
        }
      } catch (e) {
        this.$swal({type: 'error', title: e.message})
      }
    },
  },

  async created () {
    this.stateWindow = 'QueryState'
    // await this.retrieveIQCLot('')
    this.retrieveDropDown()
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    selectLanguage (language) {
    },
    getVarReturn (value) {
      switch (value.childSend) {
        case 'IQCLotBrowse':
          this.dialog.dialogBrowseIQCLot = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseIQCLot':
                  this.criteria.lot_skey = value.dataSelected[0]['lot_skey']
                  this.criteria.iqc_lot_no = value.dataSelected[0]['iqc_lot_no']
                  break
              }
          }
          break
        case 'TestItemBrowse':
          this.dialog.dialogBrowseTestItem = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseTestItem':
                  this.vDataTable.editedItem.order_item_skey = this.IQCLotData.order_item_skey
                  this.vDataTable.editedItem.test_item_skey = value.dataSelected[0]['test_item_skey']
                  this.vDataTable.editedItem.test_item_id = value.dataSelected[0]['test_item_id']
                  this.vDataTable.editedItem.test_item_desc = value.dataSelected[0]['test_item_desc']
                  break
              }
          }
          break
        case 'AnalyzerBrowse':
          this.dialog.dialogBrowseAnalyzer = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseAnalyzer':
                  this.criteria.analyzer_skey = value.dataSelected[0]['analyzer_skey']
                  this.criteria.analyzer_cd = value.dataSelected[0]['analyzer_cd']
                  this.criteria.analyzer_desc = value.dataSelected[0]['analyzer_desc']
                  break
              }
          }
          break
        case 'ResultItemBrowse':
          this.dialog.dialogBrowseResultItem = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseResultItem':
                  this.criteria.result_item_skey = value.dataSelected[0]['result_item_skey']
                  this.criteria.result_item_id = value.dataSelected[0]['result_item_id']
                  this.criteria.result_item_desc = value.dataSelected[0]['result_item_desc']
                  break
              }
          }
          break
        case 'IQCLotControlBrowse':
          this.dialog.dialogBrowseIQCLotControl = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseLotControl':
                  this.criteria.lotControl = value.dataSelected[0]['lot_control']
                  break
              }
          }
          break
        case 'IQCControlNameBrowse':
          this.dialog.dialogBrowseIQControlName = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseControlName':
                  this.criteria.controlName = value.dataSelected[0]['control_name']
                  break
              }
          }
          break
        case 'AnalyzerModelBrowse':
          this.dialog.dialogBrowseAnalyzerModel = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseAnalyzerModel':
                  this.criteria.model_skey = value.dataSelected[0]['model_skey']
                  this.criteria.model_cd = value.dataSelected[0]['model_cd']
                  this.criteria.model_desc = value.dataSelected[0]['model_desc']
                  break
              }
          }
          break
        case 'LISIQCResultAutoCalc':
          this.dialog.dialogIQCResultAutoCalc = false
          switch (value.actionReturn) {
            case 'OK':
              this.NLabMean = value.NLabMean
              this.AutoSelect()
          }
          break
      }
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTable.defaultItem = {
        win_name: '',
        window_comment: ''
      }
    },
    browseTestItem () {
      if (this.vDataTable.editedIndex === -1) {
        this.dialog.dialogBrowseTestItem = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseTestItem'
        this.$refs.TestItemBrowse.retrieveTestItem()
      }
    },
    clearTestItem () {
      this.dialog.dialogAddEdit = false
      this.vDataTable.editedItem.test_item_skey = undefined
      this.vDataTable.editedItem.test_item_id = undefined
      this.vDataTable.editedItem.test_item_desc = undefined
      this.dialog.dialogAddEdit = true
    },
    browseAnalyzer () {
      this.dialog.dialogBrowseAnalyzer = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseAnalyzer'
      this.$refs.AnalyzerBrowse.retrieveAnalyzer()
    },
    browseResultItem () {
      this.dialog.dialogBrowseResultItem = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseResultItem'
      this.$refs.ResultItemBrowse.retrieveResultItem()
    },
    browseLotControl () {
      this.dialog.dialogBrowseIQCLotControl = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseLotControl'
      this.$refs.IQCLotControlBrowse.retrieveIQCLotControl()
    },
    browseControlName () {
      this.dialog.dialogBrowseIQControlName = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseControlName'
      this.$refs.IQCControlNameBrowse.retrieveIQCControlName()
    },
    browseAnalyzerModel () {
      this.dialog.dialogBrowseAnalyzerModel = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseAnalyzerModel'
      this.$refs.AnalyzerModelBrowse.retrieveAnalyzerModel()
    },
    browseIQCLot () {
      this.dialog.dialogBrowseIQCLot = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseIQCLot'
      this.$refs.IQCLotBrowse.retrieveIQCLot()
    },
    clearAnalyzer () {
      this.criteria.analyzer_skey = -1
      this.criteria.analyzer_cd = ''
      this.criteria.analyzer_desc = ''
    },
    clearAnalyzerModel () {
      this.criteria.model_skey = -1
      this.criteria.model_cd = ''
      this.criteria.model_desc = ''
    },
    clearIQCLot () {
      this.criteria.lot_skey = -1
      this.criteria.iqc_lot_no = ''
    },
    clearResultItem () {
      this.criteria.result_item_skey = -1
      this.criteria.result_item_id = ''
      this.criteria.result_item_desc = ''
    },
    clearLotControl () {
      this.criteria.lotControl = ''
    },
    clearControlName () {
      this.criteria.controlName = ''
    },
    clearDateFromToCriteria () {
      this.criteria.dateFromTo = []
    },
    async newIQCLot () {
      await this.retrieveIQCLot('')
      this.stateWindow = 'NewState'
    },
    newIQCLotResultValue (item) {
      this.vDataTable.editedItem = Object.assign({}, item)
      // this.dialogLanguage = true
      this.iqcLotResultValueEdit = false
    },
    onRowClick (item, event) {
      this.loadGraphResultValue(item, 'Target')
      this.loadGraphResultValue(item, 'All')
      this.loadGraphResultValue(item, 'Lab')
    },
    loadGraphResultValue (item, targetType) {
      this.data.dataSeriesLine = {}
      let resultValue = this.findResultValue(item.lot_skey, item.result_item_id)
      let min
      let max

      resultValue.forEach((value, index) => {
        let dataResult = []
        let mean
        let sd
        if (targetType === 'Target') {
          mean = item.target_mean
          sd = item.target_sd
        }
        if (targetType === 'All') {
          mean = item.mean
          sd = item.sd
        }
        if (targetType === 'Lab') {
          mean = item.lab_mean
          sd = item.lab_sd
        }
        min = (mean - (3 * sd)) * 0.80
        max = (mean + (3 * sd)) * 1.2
        if (this.data.dataSeriesLine.hasOwnProperty('result')) {
          dataResult = this.data.dataSeriesLine['result']
        }
        dataResult.push({
          x: value.qc_date,
          y: parseFloat(value.result_value).toFixed(2),
          result_value_skey: value.result_value_skey,
          target_mean: value.target_mean,
          target_sd: value.target_sd,
        })
        this.data.dataSeriesLine['result'] = dataResult

        let dataUpper3SD = []
        if (this.data.dataSeriesLine.hasOwnProperty('Upper 3SD')) {
          dataUpper3SD = this.data.dataSeriesLine['Upper 3SD']
        }
        dataUpper3SD.push({
          x: value.qc_date,
          y: parseFloat(mean + (3 * sd)).toFixed(2),
          result_value_skey: value.result_value_skey,
          target_mean: value.target_mean,
          target_sd: value.target_sd,
        })
        this.data.dataSeriesLine['Upper 3SD'] = dataUpper3SD

        let dataUpper2SD = []
        if (this.data.dataSeriesLine.hasOwnProperty('Upper 2SD')) {
          dataUpper2SD = this.data.dataSeriesLine['Upper 2SD']
        }
        dataUpper2SD.push({
          x: value.qc_date,
          y: parseFloat(mean + (2 * sd)).toFixed(2),
          result_value_skey: value.result_value_skey,
          target_mean: value.target_mean,
          target_sd: value.target_sd,
        })
        this.data.dataSeriesLine['Upper 2SD'] = dataUpper2SD

        let dataUpper1SD = []
        if (this.data.dataSeriesLine.hasOwnProperty('Upper 1SD')) {
          dataUpper1SD = this.data.dataSeriesLine['Upper 1SD']
        }
        dataUpper1SD.push({
          x: value.qc_date,
          y: parseFloat(mean + sd).toFixed(2),
          result_value_skey: value.result_value_skey,
          target_mean: value.target_mean,
          target_sd: value.target_sd,
        })
        this.data.dataSeriesLine['Upper 1SD'] = dataUpper1SD

        let dataMean = []
        if (this.data.dataSeriesLine.hasOwnProperty('mean')) {
          dataMean = this.data.dataSeriesLine['mean']
        }
        dataMean.push({
          x: value.qc_date,
          y: parseFloat(mean).toFixed(2),
          result_value_skey: value.result_value_skey,
          target_mean: value.target_mean,
          target_sd: value.target_sd,
        })
        this.data.dataSeriesLine['mean'] = dataMean

        let dataLower1SD = []
        if (this.data.dataSeriesLine.hasOwnProperty('Lower 1SD')) {
          dataLower1SD = this.data.dataSeriesLine['Lower 1SD']
        }
        dataLower1SD.push({
          x: value.qc_date,
          y: parseFloat(mean - sd).toFixed(2),
          result_value_skey: value.result_value_skey,
          target_mean: value.target_mean,
          target_sd: value.target_sd,
        })
        this.data.dataSeriesLine['Lower 1SD'] = dataLower1SD

        let dataLower2SD = []
        if (this.data.dataSeriesLine.hasOwnProperty('Lower 2SD')) {
          dataLower2SD = this.data.dataSeriesLine['Lower 2SD']
        }
        dataLower2SD.push({
          x: value.qc_date,
          y: parseFloat(mean - (2 * sd)).toFixed(2),
          result_value_skey: value.result_value_skey,
          target_mean: value.target_mean,
          target_sd: value.target_sd,
        })

        this.data.dataSeriesLine['Lower 2SD'] = dataLower2SD

        let dataLower3SD = []
        if (this.data.dataSeriesLine.hasOwnProperty('Lower 3SD')) {
          dataLower3SD = this.data.dataSeriesLine['Lower 3SD']
        }
        dataLower3SD.push({
          x: value.qc_date,
          y: parseFloat(mean - (3 * sd)).toFixed(2),
          result_value_skey: value.result_value_skey,
          target_mean: value.target_mean,
          target_sd: value.target_sd,
        })
        this.data.dataSeriesLine['Lower 3SD'] = dataLower3SD
      })
      let series = []
      let yaxis = []
      let opposite = false
      let showYAxis = false
      for (const [key, value] of Object.entries(this.data.dataSeriesLine)) {
        series.push({
          name: key,
          data: value,
          type: 'line',
        })
        yaxis.push({
          opposite: opposite,
          min: min,
          max: max,
          // forceNiceScale: true,
          show: showYAxis,
          tickAmount: 6,
          decimalsInFloat: 2,
          labels: {
            formatter: (v) => { return !['sd'].includes(key) ? v : parseFloat(value[0].target_mean + (value[0].target_sd * v)).toFixed(2) },
          },
          title: {
            text: ''
          },
        })
        opposite = !opposite ? true : opposite
      }
      if (targetType === 'Target') {
        this.$refs.chartTarget.refresh()
        this.$refs.chartTarget.updateOptions({
          series: series,
          yaxis: yaxis,
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0]
          },
          stroke: {
            width: 1
          },
          xaxis: {
            type: 'datetime',
            labels: {
              format: 'dd MMM yy',
            },
          },
        })
      }
      if (targetType === 'All') {
        this.$refs.chartAll.refresh()
        this.$refs.chartAll.updateOptions({
          series: series,
          yaxis: yaxis,
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0]
          },
          stroke: {
            width: 1
          },
          xaxis: {
            type: 'datetime',
            labels: {
              format: 'dd MMM yy',
            },
          },
        })
      }
      if (targetType === 'Lab') {
        this.$refs.chartLab.refresh()
        this.$refs.chartLab.updateOptions({
          series: series,
          yaxis: yaxis,
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0]
          },
          stroke: {
            width: 1
          },
          xaxis: {
            type: 'datetime',
            labels: {
              format: 'dd MMM yy',
            },
          },
        })
      }
    },
    async deleteIQCLot () {
      this.$swal({
        text: this.stringFormat('Are you sure want to delete IQC Lot?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          await this.axios.post(process.env.VUE_APP_API + '/lis_iqc_lot_maint/deleteIQCLot' + process.env.VUE_APP_DATABASE_TYPE, {
            lot_skey: this.IQCLotData.lot_skey,
          })
            .then(async response => {
              if (response.data.isSuccess) {
                this.$swal({type: 'success', title: response.data.reasonText})
                await this.retrieveIQCLot('')
                this.stateWindow = 'QueryState'
              } else {
                await this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(async e => {
              await this.$swal({type: 'error', title: e.message})
            })
        }
      })
    },
    async saveIQCLot () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/lis_iqc_result/saveIQCResult' + process.env.VUE_APP_DATABASE_TYPE, {
        iqc_result: this.vDataTable.data,
      })
        .then(async response => {
          if (response.data.isSuccess) {
            await this.retrieveIQCLot('')
            this.stateWindow = 'SaveState'
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            await this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(async e => {
          await this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async queryIQCLot () {
      // await this.retrieveIQCLot('')
      this.vDataTable.data = []
      this.stateWindow = 'QueryState'
    },
    async findIQCLot () {
      await this.retrieveIQCLot('')
      this.stateWindow = 'FindState'
      // var IQCLotNo = this.$refs.textFieldIQCLotNo.value
      // if (IQCLotNo === undefined || IQCLotNo.length === 0) {
      //   this.dialog.dialogBrowseIQCLot = true
      //   this.sendVar.singleSelect = true
      //   this.sendVar.browseName = 'browseIQCLot'
      //   this.$refs.IQCLotBrowse.retrieveIQCLot()
      // } else {
      //   await this.retrieveIQCLot(IQCLotNo)
      //   if (this.$refs.textFieldIQCLotNo.value === undefined || this.$refs.textFieldIQCLotNo.value.length === 0) {
      //     var format = require('string-format')
      //     await this.$swal({type: 'error', title: format('Not Found IQC Lot No ({})', IQCLotNo)})
      //   } else {
      //     this.stateWindow = 'FindState'
      //   }
      // }
    },
    newResultItem () {
      if (this.IQCLotData.lot_skey.length === 0) {
        this.$swal({type: 'error', title: 'กรุณาเลือก IQC Lot ก่อนจะเพิ่มข้อมูล'})
        this.disabledControl.buttonSaveDetail = true
      } else {
        this.disabledControl.buttonSaveDetail = false
      }
    },
    async retrieveIQCLot (iqcLotNo) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/lis_iqc_result/retrieveIQCResult' + process.env.VUE_APP_DATABASE_TYPE, {
        'criteria': this.criteria,
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.data = response.data.data
            console.log(this.vDataTable.data)
            this.initialize()
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    retrieveDropDown () {
      this.axios.post(process.env.VUE_APP_API + '/lis_iqc_result/retrieveDropDown' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.dropDownData = response.data.data[0]
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    LoadResultItem () {
      this.$swal({
        text: 'Do you want to Load Result Item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then((result) => {
        if (result) {
          let analyzerSkey
          analyzerSkey = this.IQCLotData.analyzer_skey
          this.axios.post(process.env.VUE_APP_API + '/lis_iqc_lot_maint/retrieveAnalyzerModelResultItem' + process.env.VUE_APP_DATABASE_TYPE, {
            'analyzer_skey': analyzerSkey,
          })
            .then(response => {
              if (response.data.isSuccess) {
                this.utils.asyncForEach(response.data.data, async function (x) {
                  let resultItem = {}
                  resultItem.lot_skey = this.IQCLotData.lot_skey
                  resultItem.result_item_skey = x.result_item_skey
                  resultItem.result_item_id = x.result_item_id
                  resultItem.result_item_desc = x.result_item_desc
                  resultItem.uom = x.uom
                  resultItem.uom_desc = x.uom_desc
                  resultItem.factor = x.factor
                  resultItem.state_row = 'New'
                  console.log(resultItem)
                  let foundArr = this.vDataTable.data.filter(o => o.result_item_skey === x.result_item_skey)
                  if (foundArr.length === 0) {
                    this.vDataTable.data.push(resultItem)
                  }
                }.bind(this))
              } else {
                this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(e => {
              this.$swal({type: 'error', title: e.message})
            })
        }
      })
    },
    async OpenAutoSelect () {
      if (this.vDataTable.selected.length === 0) {
        this.$swal({type: 'error', title: 'Please Select Data'})
        return
      }
      this.dialog.dialogIQCResultAutoCalc = true
    },
    async AutoSelect () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
        await this.axios.post(process.env.VUE_APP_API + '/lis_iqc_lot_maint/autoSelect' + process.env.VUE_APP_DATABASE_TYPE, {
          'lot_skey': x.lot_skey,
          'result_item_skey': x.result_item_skey,
          'n_lab_mean': this.NLabMean,
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      }.bind(this))
      await this.retrieveIQCLot('')
      this.dialog.dialogProgress = false
    },
    async Calculate () {
      if (this.vDataTable.selected.length === 0) {
        this.$swal({type: 'error', title: 'Please Select Data'})
        return
      }
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
        await this.axios.post(process.env.VUE_APP_API + '/lis_iqc_lot_maint/calculate' + process.env.VUE_APP_DATABASE_TYPE, {
          'lot_skey': x.lot_skey,
          'result_item_skey': x.result_item_skey,
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      }.bind(this))
      await this.retrieveIQCLot('')
      this.dialog.dialogProgress = false
    },
    findResultValue (lotSkey, resultItemID) {
      return this.vDataTable.data.find(function (x) {
        return (x.lot_skey === lotSkey && x.result_item_id === resultItemID)
      }).lis_iqc_lot_result_value
    },
    findSelectedResultValue (lotSkey, resultItemID) {
      return this.vDataTable.data.find(function (x) {
        return (x.lot_skey === lotSkey && x.result_item_id === resultItemID)
      }).selectedIQCLotResultValue
    },
    checkDeleteselected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: 'Are you sure you want to delete selected Order Test Item?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: 'Please select Order Test Item to delete'})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
        var val = await this.deleteOrderTestItem(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))

      // del.forEach(x => {
      //   this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      // })

      for (const x in del) {
        this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
      // this.retrieveWindow(this.appName)
    },
    async deleteOrderTestItem (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var lotSkey = item.lot_skey
        var resultItemSkey = item.result_item_skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/lis_iqc_lot_maint/deleteIQCLotResultItem' + process.env.VUE_APP_DATABASE_TYPE, {
          lot_skey: lotSkey,
          result_item_skey: resultItemSkey,
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.vDataTable.data.indexOf(item) >= 0) {
                this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    editItem (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEdit = true
    },
    editResultValue (item) {
      this.vDataTable.editedResultValueIndex = this.findResultValue(item.lot_skey, item.result_item_id).indexOf(item)
      this.vDataTable.editedResultValueItem = Object.assign({}, item)
      this.dialog.dialogAddEditResultValue = true
    },
    async deleteItemConfirm (item) {
      // this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      // this.vDataTable.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Are you sure want to delete Result Item?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteOrderTestItem(item)
          if (val !== undefined) {
            if (this.vDataTable.selected.indexOf(item) >= 0) {
              this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(item), 1)
            }
          }
        }
      })
    },
    async deleteResultValue (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var resultValueSkey = item.result_value_skey
        var valRet
        if (resultValueSkey === undefined) {
          resultValueSkey = -1
        }
        await this.axios.post(process.env.VUE_APP_API + '/lis_iqc_result/deleteResultValue' + process.env.VUE_APP_DATABASE_TYPE, {
          result_value_skey: resultValueSkey,
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.findResultValue(item.lot_skey, item.result_item_id).indexOf(item) >= 0) {
                this.findResultValue(item.lot_skey, item.result_item_id).splice(this.findResultValue(item.lot_skey, item.result_item_id).indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async deleteResultValueConfirm (item) {
      if (item.result_type === 'Instrument Result') {
        this.$swal({type: 'error', title: 'Cannot delete because Instrument Result'})
        return
      }
      this.vDataTable.editedResultValueIndex = this.findResultValue(item.lot_skey, item.result_item_id).indexOf(item)
      this.vDataTable.editedResultValueItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Are you sure delete Result Value?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteResultValue(item)
          if (val !== undefined) {
            var selectedIQCLotResultValue = this.findSelectedResultValue(item.lot_skey, item.result_item_id)
            if (selectedIQCLotResultValue.indexOf(item) >= 0) {
              selectedIQCLotResultValue.splice(selectedIQCLotResultValue.indexOf(item), 1)
            }
          }
          this.vDataTable.editedResultValueItem = Object.assign({}, this.vDataTable.defaultResultValueItem)
          this.vDataTable.editedResultValueIndex = -1
        }
      })
    },
    close () {
      this.dialog.dialogAddEdit = false
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    closeResultValue () {
      this.dialog.dialogAddEditResultValue = false
      this.$nextTick(() => {
        this.vDataTable.editedResultValueItem = Object.assign({}, this.vDataTable.defaultResultValueItem)
        this.vDataTable.editedResultValueIndex = -1
      })
    },
    async save () {
      if (this.vDataTable.editedItem.result_item_skey === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Result Item'})
        return
      }
      if (this.vDataTable.editedItem.target_mean === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Target Mean'})
        return
      }
      if (this.vDataTable.editedItem.target_sd === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Target SD'})
        return
      }
      if (this.vDataTable.editedIndex > -1) {
        if (this.vDataTable.editedItem.state_row === 'New') {
        } else {
          this.vDataTable.editedItem.state_row = 'Edit'
        }
        Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
        this.close()
      } else {
        let foundArr = this.vDataTable.data.filter(x => x.result_item_skey === this.vDataTable.editedItem.result_item_skey)
        if (foundArr.length === 0) {
          this.vDataTable.editedItem.state_row = 'New'
          this.vDataTable.data.push(this.vDataTable.editedItem)
        }
        this.close()
      }
    },
    async saveResultValue () {
      if (this.vDataTable.editedResultValueIndex > -1) {
        if (this.vDataTable.editedResultValueItem.state_row === 'New') {
        } else {
          this.vDataTable.editedResultValueItem.state_row = 'Edit'
        }
        Object.assign(this.findResultValue(this.vDataTable.editedResultValueItem.lot_skey, this.vDataTable.editedResultValueItem.result_item_id)[this.vDataTable.editedResultValueIndex], this.vDataTable.editedResultValueItem)
      } else {
        this.vDataTable.editedResultValueItem.state_row = 'New'
        this.vDataTable.editedResultValueItem.lot_skey = this.vDataTable.editedItem.lot_skey
        this.vDataTable.editedResultValueItem.result_item_skey = this.vDataTable.editedItem.result_item_skey
        this.vDataTable.editedResultValueItem.result_item_id = this.vDataTable.editedItem.result_item_id
        this.vDataTable.editedResultValueItem.result_item_desc = this.vDataTable.editedItem.result_item_desc
        this.vDataTable.editedResultValueItem.result_type = 'Manual Result'
        this.findResultValue(this.vDataTable.editedItem.lot_skey, this.vDataTable.editedItem.result_item_id).push(this.vDataTable.editedResultValueItem)
      }
      this.closeResultValue()
    },
  },
}
</script>
<style scoped>
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
</style>